<template>
  <d-page>
    <van-grid class="mt12" :border="false" :column-num="3">
      <van-grid-item>
        <d-icon name="search"></d-icon>
        <p>search</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="share"></d-icon>
        <p>share</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="arrow_right"></d-icon>
        <p>arrow_right</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="plus"></d-icon>
        <p>plus</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="minus"></d-icon>
        <p>minus</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="search_eliminate"></d-icon>
        <p>search_eliminate</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="add"></d-icon>
        <p>add</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="close"></d-icon>
        <p>close</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="clock"></d-icon>
        <p>clock</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="coupon"></d-icon>
        <p>coupon</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="more"></d-icon>
        <p>more</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="like"></d-icon>
        <p>like</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="location"></d-icon>
        <p>location</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="location_fill"></d-icon>
        <p>location_fill</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="home"></d-icon>
        <p>home</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="popup_close"></d-icon>
        <p>popup_close</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="return"></d-icon>
        <p>return</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="refresh"></d-icon>
        <p>refresh</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="star"></d-icon>
        <p>star</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="star_fill"></d-icon>
        <p>star_fill</p>
      </van-grid-item>
      <van-grid-item>
        <d-icon name="telephone"></d-icon>
        <p>telephone</p>
      </van-grid-item>
    </van-grid>
  </d-page>
</template>

<script>
  import { Grid, GridItem } from 'vant'
  import DPage from '../../../components/d-page/index'
  import DIcon from '../../../components/d-icon/index'

  export default {
    name: 'index',
    components: { DIcon, DPage, [Grid.name]: Grid, [GridItem.name]: GridItem }
  }
</script>

<style scoped lang="scss">
  /deep/ {
    .d-icon {
      font-size: 22px;
    }
  }

  p {
    margin-top: 4px;
    color: #666666;
  }
</style>
